import { useEffect } from 'react';
import { usePageTitle } from '@/hooks/usePageTitle';
import { PageHeader } from '@/components/ui/page-header';
import { TableSkeleton } from '@/components/ui/skeleton';
import { useUserStore } from '../store';
import { UserTable } from '../components';

export function UserManagementPage() {
  usePageTitle('User Management');
  const { users, isUsersLoading: isLoading, usersError: error, fetchUsers } = useUserStore();

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  return (
    <div className="space-y-6">
      <PageHeader
        title="User Management"
        description="View and manage system users, their roles, and permissions."
      />
      {isLoading && users.length === 0 ? (
        <TableSkeleton rows={8} cols={12} />
      ) : error ? (
        <div className="flex flex-col items-center justify-center h-64 space-y-4">
          <p className="text-destructive">{error}</p>
          <button
            onClick={() => fetchUsers()}
            className="text-sm text-primary hover:underline"
          >
            Try again
          </button>
        </div>
      ) : (
        <UserTable data={users} />
      )}
    </div>
  );
}
